import { TimetableCard } from '@features/timetables/components/TimetableCard'
import { getTodayDateValue } from '@features/timetables/dateUtils'
import { useStaffTimetable } from '@features/timetables/queries'
import { ScrollArea } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

export const Route = createFileRoute('/_layout/staff/$initials/timetable')({
  component: RouteComponent,
})

function RouteComponent() {

    const { initials } = Route.useParams()
    const [date, setDate] = useState(getTodayDateValue)
    const { data: lessons, isLoading, isError } = useStaffTimetable({ initials, date })

    return (
        <ScrollArea h="100%" type="auto" className="min-h-0" p={'xs'}>
            <TimetableCard
                lessons={lessons}
                loading={isLoading}
                error={isError}
                cardTitle={`Timetable: ${initials}`}
                timetableType="staff"
                date={date}
                onDateChange={setDate}
                style={{ minHeight: '30rem' }}
            />
        </ScrollArea>
    )
}
